import React, { useState, useEffect } from "react";
import EventNoteIcon from "@mui/icons-material/EventNote";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LicenseTable from "./components/LicenseTable";
import { axiosInstance } from "../axiosInstance";
import CompanyInfo from "./components/CompanyInfo";
import loader from "./../assets/loader.webp";

function Home() {
  const [dataDetails, setDataDetails] = useState(null);
  const [expiredData, setExpiredData] = useState([]);
  const [almostExpiredData, setAlmostExpiredData] = useState([]);
  const [loading, setLoading] = useState(true); // Initially set loading to true

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(
        "/api/superadmin/dashboard/stats"
      );
      setDataDetails(response.data.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }

    try {
      const response = await axiosInstance.get(
        "/api/superadmin/dashboard/expired"
      );
      setExpiredData(response?.data?.data);
    } catch (err) {
      console.log("Error fetching data", err);
    } finally {
      setLoading(false);
    }

    try {
      const response = await axiosInstance.get(
        "/api/superadmin/dashboard/about-to-expire"
      );
      setAlmostExpiredData(response?.data?.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  if (loading) {
    return (
      <div className="w-full h-screen  flex justify-center items-center">
        <img src={loader} alt="loader" className="w-20 " />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-row overflow-x-auto gap-3 md:gap-1 justify-between">
        <CompanyInfo
          icon={<EventNoteIcon />}
          detail={"Total Companies"}
          number={dataDetails?.totalCompanies}
        />
        <CompanyInfo
          icon={<TaskAltIcon />}
          detail={"Active Companies"}
          number={dataDetails?.activeCompanies}
          className="text-green-500"
        />
        <CompanyInfo
          icon={<HighlightOffIcon />}
          detail={"Inactive Companies"}
          number={dataDetails?.inactiveCompanies}
          className="text-red-400"
        />
        <CompanyInfo
          icon={<PeopleAltIcon />}
          detail={"Total Users"}
          number={dataDetails?.totalUsers}
        />
      </div>

      <div className="flex flex-col justify-center items-center  gap-4 lg:items-start lg:justify-between">
        <div className="bg-gray-800 w-full  text-white p-4 rounded-lg">
          <h3 className="text-2xl font-medium pb-2">About to expire</h3>
          <LicenseTable data={almostExpiredData} />
        </div>
        <div className="bg-gray-800 w-full  text-white p-4 rounded-lg">
          <h3 className="text-2xl font-medium pb-2">Expired licenses</h3>
          <LicenseTable data={expiredData} className="text-red-500" />
        </div>
      </div>
    </div>
  );
}

export default Home;
